var e=(e,i,t)=>({key:e,type:"primitive",...t?{op:t}:{},value:i});export{e as makeFilterItemPrimitive};
//# sourceMappingURL=makeFilterItemPrimitive.js.map